const createSku = (...values) => (
  values
    .join('_')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9-_]+/g, '_')
    .replace(/(?:(-)[-_]*)|(?:(_)[-_]*)/g, '$1$2')
    .replace(/(?:^[-_]+)|(?:[-_]+$)/g, '')
    .toUpperCase()
);

export default createSku;
